<template>

  <div id="users">

    <Datatable
      class="datatable"
      entity="user"
      ref="datatable"
      :parameters="{
        branch: $route.query.company ? undefined : $route.query.branch,
        company: $route.query.company ? $route.query.company : 'null',
        role: $route.params.role
      }"
      :onRowClick="onRowEdit"
      :globalActions="[{text: 'users.new', method: onUserCreate, condition: function() { return $store.getters.loggedUserHasModifyPermission}}]"
      :rowActions="[
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserHasModifyPermission}}
      ]"/>

    <Modal
      name="confirmation"
      :title="$t('branches.confirmation')"
      dismissable
      :actions="[{name: $t('back'), action: 'close'}, {name: confirmationActionName, action: confirmationAction, primary: true}]">
      <p v-html="confirmationHtml"></p>
      <input type="text" class="w-100" v-model="confirmationText">
    </Modal>

  </div>

</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import { mapActions } from 'vuex';

  export default {

    name: 'users',

    components: { Datatable },

    data() {
      return {
        actionRow: {},
        errorKey: "",
        confirmationText: "",
        confirmationActionName: "",
        confirmationAction: "",
        confirmationHtml: "",
        confirmationModel: ""
      }
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "users.title";
      this.$store.state.pageIcon = "/icon/user.svg";
    },

    methods: {

      ...mapActions(["deleteUser"]),

      onUserCreate() {
        this.$router.push({ path: '/user/new', query: this.$route.query });
      },

      onRowEdit(row) {
        let query = Object.assign({}, this.$route.query, { user: row.id });
        this.$router.push({ path: '/user/edit', query: query });
      },

      onRowDelete(row) {
        this.actionRow = row;
        this.confirmationActionName = this.$t('datatable.delete');
        this.confirmationAction = this.deleteUserCallback;
        this.confirmationHtml = this.$t('users.delete_p1') + this.actionRow.username;
        this.confirmationText = "";
        this.$modal.show("confirmation");
      },

      async deleteUserCallback() {
        if (this.confirmationText.toLowerCase() !== this.actionRow.username.toLowerCase()) {
          this.errorKey = "users.error.delete_no_match";
          this.$modal.show("error");
          return;
        }
        this.$store.commit("showSpinner", true);
        let response = await this.deleteUser({id: this.actionRow.id});
        if (response) {
          this.$modal.show("confirmation", false);
          this.$refs.datatable.query();
          this.$store.commit("showSpinner", false);
        } else {
          this.$store.commit("showSpinner", false);
          this.errorKey = "error.no_server";
          this.$modal.show("error");
        }
      }
    }
  };

</script>

<style lang="scss" scoped>

</style>